// src/services/passcodeApi.ts
import apiClient from "./apiClient";

export const checkPasscodeApi = async (): Promise<{
  exists: boolean;
  enabled: boolean;
}> => {
  const { data } = await apiClient.get("/auth/passcode");
  return data;
};

export const verifyPasscodeApi = async (
  passcode: string
): Promise<{ message: string }> => {
  const { data } = await apiClient.post("/auth/passcode/verify", { passcode });
  // server should set an HttpOnly signed cookie "screen_unlocked=1" here
  return data;
};

export const setPasscodeApi = async (
  accountPassword: string,
  newPasscode: string
): Promise<{ message: string }> => {
  const { data } = await apiClient.post("/auth/passcode", {
    password: accountPassword,
    passcode: newPasscode,
  });
  return data;
};

export const lockScreenApi = async (): Promise<{ ok: true }> => {
  const { data } = await apiClient.post("/auth/passcode/lock");
  return data;
};

export const setFinanceLockEnabledApi = async (
  enabled: boolean
): Promise<{ enabled: boolean }> => {
  const { data } = await apiClient.put("/auth/passcode", { enabled });
  return data;
};
